<template>
    <el-select v-model="currentClientId" clearable filterable remote :placeholder="placeholder||'客户'"
               :remote-method="handleSearch"
               :loading="loading"
               @change="handleChange"
               style="width: 140px;">
        <el-option
            v-for="item in tableList.data"
            :key="item.id"
            :label="item.name + '（' +item.code + '）'"
            :value="item.id">
            <span class="wrap-text" style="float: left" v-if="isPermit">{{item.name}}</span>
            <span class="wrap-text" :style=" isPermit ? 'float: right; color: #8492a6; font-size: 13px' : ''">{{item.code}}</span>
        </el-option>
        <el-pagination
            background
            layout="total, sizes, prev, pager, next"
            :total="tableList.count"
            :current-page.sync="tableList.page"
            :page-size.sync="tableList.pageSize"
            @size-change="()=>tableList.load()"
            @current-change="()=>tableList.load()"
        >
        </el-pagination>
    </el-select>
</template>

<script>
    import lodash from 'lodash';
    export default {
        name: "ClientSelectList",
        props: {
            value: [Number, String],
            permissionId: String,
            tableList: Object,
            placeholder: String
            // loading: Boolean,
            // onSearch: Function,
        },
        data() {
            return {
                loading: false,
                currentClientId: this.value,
            };
        },
        computed: {
            isPermit() {
                return true;
            },
        },
        methods: {
            handleChange(v) {
                // console.log("handleChange >>>", v);
                this.currentClientId = v;
                this.$emit("input", this.currentClientId);
            },
            handleSearch(keywords) {
                console.log("handleSearch >>>", keywords)
                const search = () => {
                    this.loading = true;
                    this.tableList.searchForm.keywords = keywords;
                    this.tableList.load().then(() =>
                    {
                        this.loading = false;
                        return this.tableList.data;
                    });
                };

                lodash.debounce(search, 300)();
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/erp/components/form/ClientSelectList.vue